<template>
  <div :class="`formulate-input-element  formulate-input-element--${context.type}`"

       :data-type="context.type"
  >

    <date-picker
        v-model="context.model"
        @blur="context.blurHandler"
        v-bind="context.attributes"
        class="datepicker--hide-y"
        :disabled-date="disabledInThePastAndAfter30Days"
        valueType="format"
        popup-class="hide-year"
        format="DD/MM/YYYY"
        title-format="DD/MM/YYYY"></date-picker>

  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'

export default {
  props: {
    context: {
      type: Object,
      required: true
    },
  },
  components: {
    DatePicker
  },
  data () {
    return {

    }
  },
  watch: {
    model () {
    }
  },
  computed: {
    model () {
      return this.context.model
    }
  },
  methods: {
    disabledInThePastAndAfter30Days(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today || date > new Date(today.getTime() + 30 * 24 * 3600 * 1000);
    },
  },
}
</script>

<style>

</style>